/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useMemo, useRef, useState } from 'react';
import { ModalProps } from './modal.create.post.type';
import { useDropzone } from 'react-dropzone';
import VerifyBadge from '../../../components/verify-badge/verify-badge.component';
import ReactPlayer from 'react-player';
import {
  createNewPost,
  createNewPostInGroup,
  editOldPost,
  fetchPostCategoriesApi,
  fetchUrlImages,
  fetchUrlVideos,
  getDetailPost,
} from '../../../api';
import { useUserProfile } from '../../../hooks';
import DialogComponent from '../../../components/dialog/dialog.component';
import TextareaAutosize from 'react-textarea-autosize';
import Select, { IOption } from '../../../select/select.component';
import toast from 'react-hot-toast';
import { Image, Trash } from 'lucide-react';
import Autocomplete, {
  AutocompleteItem,
} from '../../../components/autocomplete/autocomplete';
import { useHashTag } from '../../../hooks/hashtag/useHashtag';
import ButtonPrimary from '../../../components/button-refactor/button-primary';
import Avatar from '../../../components/avatar/avatar.component';
import _get from 'lodash/get';
import { RootState } from '../../../configuration';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { CustomDropdown } from '../../user-setting/tabs/custom-dropdown';

interface PostCategory {
  id: string;
  slug: string;
  name: string;
  description: string;
  thumbnail: string;
  status: number;
  isSoftDeleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

const ModalCreatePost = (props: ModalProps) => {
  const {
    isOpen,
    reset,
    onCreatePost,
    isEdit,
    onClose,
    onClearIdDetail,
    onOpen,
    onFetch,
    isGroup,
  } = props;
  const [open, setOpen] = useState(isOpen);
  const [hashTagText, setHashTagText] = useState<string>('');
  const [textAreaContent, setTextAreaContent] = useState<string>('');
  const [isUploadImage, setIsUploadImage] = useState(false);
  const { groupId } = useParams<{ groupId: string }>();
  const [isChangeCategory, setIsChangeCategory] = useState(false);
  const [imageIds, setImageIds] = useState<string[]>([]);
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [videoIds, setVideoIds] = useState<string[]>([]);
  const [videoUrls, setVideoUrls] = useState<string[]>([]);
  const [postCategory, setPostCategories] = useState<PostCategory[]>([]);
  const [categoryId, setCategoryId] = useState<string>('');
  const [isSensitive, setIsSensitive] = useState<boolean>(false);
  const [postType, setPostType] = useState<string>('normal');
  const [detailPostData, setDetailPostData] = useState<any>({});
  const [idPostDetail, setIdPostDetail] = useState(isEdit);
  const { profile } = useUserProfile();
  const navigate = useNavigate();
  const profileUser = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const userId = profile?.userId;

  const handleClose = () => {
    reset?.(false);

    if (onOpen) {
      onOpen();
    }

    if (onClose) {
      onClose(true);
    }
    if (onClearIdDetail) {
      onClearIdDetail();
    }
    setIdPostDetail('');
  };

  const contentRef = useRef<HTMLTextAreaElement>(null);

  const handleChangTextArea = (e) => {
    setTextAreaContent(e.target.value);
  };

  const [loadingUpload, setLoadingUpload] = useState<boolean>(false);
  const [posting, setPosting] = useState<boolean>(false); // QA S-31: chống đăng bài 2 lần
  const [files, setFiles] = useState<File[]>([]);
  const [preview, setPreview] = useState<string[]>([]);
  const [hashTags, setHashTags] = useState<string>('');

  const onDrop = (acceptedFiles: File[]) => {
    const previewUrls = acceptedFiles.map((file) => {
      return URL.createObjectURL(file);
    });

    setFiles((prev) => [...prev, ...acceptedFiles]);
    setPreview([...preview, ...previewUrls]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  // Rà soát 28/10: trước đây xoá ảnh xem trước không bỏ id/url khỏi bài, và mỗi lần số file đổi thì tải lại TOÀN BỘ
  // file rồi nối thêm id ⇒ bài có ảnh trùng hoặc ảnh đã xoá. Nay nhớ kết quả tải theo từng File, chỉ tải file mới,
  // và dựng lại danh sách id/url theo đúng các file còn lại.
  type UploadedMedia = { kind: 'image' | 'video'; ids: string[]; urls: string[] };
  const uploadedRef = useRef<Map<File, UploadedMedia>>(new Map());
  const filesRef = useRef<File[]>(files);
  filesRef.current = files;
  const inFlightRef = useRef<Set<File>>(new Set());

  const rebuildMediaLists = (currentFiles: File[]) => {
    const imgIds: string[] = [];
    const imgUrls: string[] = [];
    const vidIds: string[] = [];
    const vidUrls: string[] = [];
    currentFiles.forEach((f) => {
      const m = uploadedRef.current.get(f);
      if (!m) return;
      if (m.kind === 'image') {
        imgIds.push(...m.ids);
        imgUrls.push(...m.urls);
      } else {
        vidIds.push(...m.ids);
        vidUrls.push(...m.urls);
      }
    });
    setImageIds(imgIds);
    setImageUrls(imgUrls);
    setVideoIds(vidIds);
    setVideoUrls(vidUrls);
  };

  const handleClearImage = (obj, link) => {
    const newListFile = files.filter((file) => file !== obj);
    setFiles(newListFile);
    const newPreview = preview.filter((url) => url !== link);
    setPreview(newPreview);
    uploadedRef.current.delete(obj);
    rebuildMediaLists(newListFile);
  };

  useEffect(() => {
    const pending = files.filter(
      (f) => !uploadedRef.current.has(f) && !inFlightRef.current.has(f)
    );
    if (!pending.length) {
      rebuildMediaLists(files);
      return;
    }
    const handleUploadImages = async () => {
      try {
        setLoadingUpload(true);
        const handles = pending.map(async (item) => {
          inFlightRef.current.add(item);
          try {
            if (item?.type.startsWith('image')) {
              const m = await handleGetUrlFileImage(item);
              if (m) uploadedRef.current.set(item, m);
            } else if (item?.type.startsWith('video')) {
              setPostType('video');
              const m = await handleGetUrlFileVideo(item);
              if (m) uploadedRef.current.set(item, m);
            }
          } finally {
            inFlightRef.current.delete(item);
          }
        });

        await Promise.all(handles);
      } catch (error) {
        //
      } finally {
        setLoadingUpload(false);
        // Dựng theo danh sách file MỚI NHẤT (người dùng có thể đã xoá file trong lúc đang tải).
        rebuildMediaLists(filesRef.current);
      }
    };

    handleUploadImages();
  }, [files.length]);

  const handleGetUrlFileImage = async (item): Promise<UploadedMedia | null> => {
    const formData = new FormData();
    formData.append('type', item);
    const res = await fetchUrlImages(formData);
    if (!res.length) return null;
    return {
      kind: 'image',
      ids: res.map((img) => img?.id),
      urls: res.map((img) => img?.url),
    };
  };

  const handleGetUrlFileVideo = async (item): Promise<UploadedMedia | null> => {
    const formData = new FormData();
    formData.append('type', item);
    try {
      const res = (await fetchUrlVideos(formData)) as any[];
      // Backend trả từng file kèm status; video vượt dung lượng → status 'Failed' + lý do rõ.
      const failed = res.filter((v: any) => v?.status === 'Failed' || !v?.id);
      const ok = res.filter((v: any) => v?.status !== 'Failed' && v?.id);
      if (failed.length) {
        toast.error(failed[0]?.error || 'Tải video lên thất bại.', {
          position: 'top-right',
          duration: 6000,
        });
      }
      if (!ok.length) return null;
      return {
        kind: 'video',
        ids: ok.map((video: any) => video?.id),
        urls: ok.map((video: any) => video?.url),
      };
    } catch (e: any) {
      toast.error(
        `Tải video lên thất bại: ${
          e?.response?.data?.message || e?.message || 'lỗi mạng, thử lại.'
        }`,
        { position: 'top-right', duration: 6000 }
      );
      return null;
    }
  };

  useEffect(() => {
    handleGetPostCategories();
  }, []);

  const handleGetPostCategories = async () => {
    const res = await getCategory();
    setPostCategories(res as unknown as PostCategory[]);
  };

  const getCategory = async () => {
    const res = await fetchPostCategoriesApi();
    return res;
  };

  const validateForm = () => {
    if (!textAreaContent) {
      toast.error('Nhập nội dung', {
        position: 'top-right',
      });
      return false;
    }

    if (!categoryId && !isGroup && !isSensitive) {
      toast.error('Chọn danh mục', {
        position: 'top-right',
      });
      return false;
    }
    if (!hashTags && !hashTagText) {
      toast.error('Vui lòng nhập hashtag', {
        position: 'top-right',
      });
      return false;
    }
    return true;
  };

  const handleCreateNewPost = async () => {
    if (!validateForm()) {
      return;
    }
    if (posting) return; // QA S-31: chặn bấm 2 lần -> đăng trùng bài
    setPosting(true);
    try {

    const imageInfo = imageIds.map((id, index) => {
      return {
        imageId: id,
        imageUrl: imageUrls[index],
      };
    });

    const videoInfo = videoIds.map((id, index) => {
      return {
        videoId: id,
        videoUrl: videoUrls[index],
      };
    });
    // TODO: fix bug
    if (!isGroup) {
      const data = {
        userId,
        postType,
        categoryId: isSensitive ? undefined : categoryId,
        isSensitive,
        hashtags: hashTags || hashTagText,
        content: textAreaContent,
        title: textAreaContent,
        imageInfo,
        videoInfo,
      };

      const newPost = await createNewPost(data);
      setOpen(false);
      onCreatePost?.(newPost);
    } else if (isGroup) {
      const data = {
        postType,
        hashtags: hashTags || hashTagText,
        content: textAreaContent,
        title: textAreaContent,
        imageInfo,
        videoInfo,
        groupId,
      };

      const newPost = await createNewPostInGroup(data);
      setOpen(false);
      onCreatePost?.(newPost);
    }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Đăng bài thất bại, vui lòng thử lại.');
    } finally {
      setPosting(false);
    }
  };

  useEffect(() => {
    if (idPostDetail) {
      handleGetDetailPost(idPostDetail);
    }
  }, [idPostDetail]);

  const handleGetDetailPost = async (postId) => {
    const res = await getDetailPost(postId);
    setDetailPostData(res);
  };

  useEffect(() => {
    setTextAreaContent(detailPostData.content);
    setCategoryId(detailPostData.categoryId);
    setIsSensitive(detailPostData.isSensitive || false);
    if (typeof detailPostData?.hashtags === 'string') {
      setHashTags(detailPostData?.hashtags);
    } else if (detailPostData?.hashtags?.isArray()) {
      const listHashtagArray = detailPostData?.hashtags;
      const hashtags = listHashtagArray?.join(', ');
      setHashTags(hashtags);
    }
  }, [detailPostData]);

  const handleEditPost = () => {
    const data = {
      postId: idPostDetail,
      content: textAreaContent,
      imageUrls,
      videoUrls,
    };
    editPost(data);
  };

  const editPost = async (data) => {
    const res = await editOldPost(data);
    if (res) {
      if (onOpen) {
        onOpen();
      }
      if (onFetch) {
        onFetch();
      }
    }
  };

  const categoryOptions = useMemo(() => {
    const options = postCategory.map((category) => {
      const res: IOption = {
        label: category.name,
        value: category.id,
      };
      return res;
    });

    return options;
  }, [postCategory]);

  const { hashtags: hashtagsResponse, searchHashTags } = useHashTag();

  const hashTagOptions = useMemo(() => {
    if (!hashtagsResponse) {
      return [];
    }

    const res: AutocompleteItem[] = hashtagsResponse.map((hashtag) => {
      const option: AutocompleteItem = {
        label: hashtag.name,
        value: hashtag.name,
      };

      return option;
    });

    return res;
  }, [hashtagsResponse]);

  return (
    <DialogComponent
      onClose={() => handleClose()}
      visible={open}
      placement="CENTER"
      title={!idPostDetail ? 'Tạo bài viết' : 'Chỉnh sửa bài viết'}
      size="full"
      customSize="w-full max-w-[976px]"
    >
      <div className="w-full">
        <div className="p-6 gap-3 flex flex-col">
          <div className="flex px-3 py-2 gap-2 items-center ">
            <Avatar
              avatar={_get(profile, 'avatar', '')}
              label={_get(profile, 'fullname', '')}
              size="sm"
            />
            <div className="flex flex-col gap-1 ">
              <div className="flex gap-2 items-center">
                <h3 className="text-slate-800 dark:text-slate-50 font-semibold text-sm">
                  {_get(profileUser, 'fullname', '')}
                </h3>
                <VerifyBadge userType={profile?.userType} />
              </div>
            </div>
          </div>
          {!isGroup && (
            <label className="mb-2 flex w-fit cursor-pointer items-center gap-2 rounded-md px-1 text-sm font-medium text-[#E11D48]">
              <input
                type="checkbox"
                className="h-4 w-4 accent-red-600"
                checked={isSensitive}
                onChange={(e) => {
                  setIsSensitive(e.target.checked);
                  if (e.target.checked) {
                    setCategoryId('');
                    setIsChangeCategory(false);
                  }
                }}
              />
              <span>Nội dung nhạy cảm (18+)</span>
            </label>
          )}
          <div className={`w-fit ${isSensitive ? 'hidden' : ''}`}>
            {!isChangeCategory && !isGroup && (
              <p
                onClick={() => setIsChangeCategory(true)}
                className=" h-10 flex items-center  text-[#111827] border-[#DEE0E6] dark:border-slate-700 w-[190px] text-base dark:text-slate-50  font-medium cursor-pointer border border-solid rounded-md px-3 py-1 "
              >
                {categoryOptions.find((item: any) => item.value === categoryId)
                  ?.label
                  ? categoryOptions.find(
                      (item: any) => item.value === categoryId
                    )?.label
                  : 'Chọn danh mục'}
              </p>
            )}
            {isChangeCategory &&
              (!idPostDetail ? (
                <div>
                  {/* <Select
                    className="!h-10"
                    options={categoryOptions}
                    onChange={(data: any) => {
                      setCategoryId(data.value);
                      setIsChangeCategory(false);
                    }}
                    placeholder="Chọn danh mục"
                  /> */}
                  <CustomDropdown
                    value={categoryId}
                    options={categoryOptions}
                    placeholder="Chọn danh mục"
                    customClassName=" h-10 px-3 py-1 w-[190px] text-base font-medium"
                    onChange={(val) => {
                      setCategoryId(val);
                      setIsChangeCategory(false);
                    }}
                  />
                </div>
              ) : (
                <span className="outline-none border border-[#1D8DE3] text-[#1D8DE3] rounded-[4px] float-right min-w-[100px] text-center px-2">
                  {categoryOptions.find((item: any) => item.value === categoryId)
                    ?.label ||
                    detailPostData?.categoryName ||
                    'Chọn danh mục'}
                </span>
              ))}
          </div>
          {/* Click bất kỳ đâu trong ô (kể cả vùng padding) → focus vào textarea (trước đây chỉ click trúng
              đúng dải textarea xám mới nhập được, click vùng trống quanh nó không ăn). */}
          <div
            className="w-full border border-solid rounded-lg p-4 pb-12 cursor-text"
            onClick={() => contentRef.current?.focus()}
          >
            <div className="flex gap-2 pb-5">
              <TextareaAutosize
                ref={contentRef}
                className="outline-none  text-slate-800 dark:text-slate-50 bg-zinc-50 dark:bg-transparent
              rounded-md w-full resize-none text-sm"
                onChange={(e) => handleChangTextArea(e)}
                value={textAreaContent}
                placeholder="Bạn đang nghĩ gì?"
                autoFocus
              />
            </div>
          </div>
          <div>
            {!idPostDetail && hashtagsResponse ? (
              <Autocomplete
                items={hashTagOptions}
                onChange={(value) => {
                  setHashTags(value as string);
                }}
                onInputChange={(inputValue) => {
                  setHashTagText(inputValue);
                }}
                onNoneItem={(inputValue) => {
                  searchHashTags(inputValue);
                }}
                placeholder="Hashtag"
              />
            ) : (
              <span className="inline-block flex-1 text-xs">{hashTags}</span>
            )}
          </div>

          <div>
            <div
              className="w-full min-h-[147px] py-5 flex justify-center items-center cursor-pointer rounded-md z-10
              border border-dotted border-zinc-400 dark:border-zinc-50"
            >
              <div {...getRootProps()} className="w-full h-full">
                <input
                  {...getInputProps()}
                  id="upload-post"
                  type="file"
                  accept="image/*,video/*"
                  multiple
                />

                {preview.length > 0 ? (
                  <div>
                    <div className="w-full h-full grid grid-cols-2 px-4 gap-3">
                      {files?.map((item, index) => {
                        if (item?.type?.startsWith('image')) {
                          return (
                            <div key={index} className="relative">
                              <img
                                src={preview[index]}
                                alt="Preview"
                                className="inline-block object-cover w-full h-48"
                              />
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClearImage(item, preview[index]);
                                }}
                                className="cursor-pointer absolute rounded-md right-2 top-2 text-slate-800 w-6 h-6
                                flex justify-center items-center bg-slate-50"
                              >
                                <Trash size={14} />
                              </span>
                            </div>
                          );
                        }
                        return (
                          <div
                            key={index}
                            className="relative w-[100px] h-[100px] mr-[20px] overflow-hidden"
                          >
                            <ReactPlayer
                              url={preview[index]}
                              controls
                              className="object-fill w-full h-full"
                            />
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClearImage(item, preview[index]);
                              }}
                              className="cursor-pointer absolute bg-[#E4E6EB] w-[20px] h-[20px] rounded-full left-[0px] top-[0px] text-[30px] flex justify-center items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 50 50"
                                width="10px"
                                height="10px"
                              >
                                <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z" />
                              </svg>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    <div className="flex justify-center mt-4">
                      <p className="text-sm text-slate-600 dark:text-slate-50">
                        Click anywhere to add more files
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    <div className="cursor-pointer items-center justify-center flex flex-col gap-3">
                      <div className="font-medium p-2 flex items-center gap-[10px] text-base text-[#657384] dark:text-slate-50">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5798 19.51L2.5598 19.53C2.2898 18.94 2.1198 18.27 2.0498 17.53C2.1198 18.26 2.3098 18.92 2.5798 19.51Z"
                            fill="#657384"
                          />
                          <path
                            d="M9.00012 10.88C10.3146 10.88 11.3801 9.81443 11.3801 8.5C11.3801 7.18556 10.3146 6.12 9.00012 6.12C7.68568 6.12 6.62012 7.18556 6.62012 8.5C6.62012 9.81443 7.68568 10.88 9.00012 10.88Z"
                            fill="#657384"
                          />
                          <path
                            d="M16.19 2.5H7.81C4.17 2.5 2 4.67 2 8.31V16.69C2 17.78 2.19 18.73 2.56 19.53C3.42 21.43 5.26 22.5 7.81 22.5H16.19C19.83 22.5 22 20.33 22 16.69V14.4V8.31C22 4.67 19.83 2.5 16.19 2.5ZM20.37 13C19.59 12.33 18.33 12.33 17.55 13L13.39 16.57C12.61 17.24 11.35 17.24 10.57 16.57L10.23 16.29C9.52 15.67 8.39 15.61 7.59 16.15L3.85 18.66C3.63 18.1 3.5 17.45 3.5 16.69V8.31C3.5 5.49 4.99 4 7.81 4H16.19C19.01 4 20.5 5.49 20.5 8.31V13.11L20.37 13Z"
                            fill="#657384"
                          />
                        </svg>

                        <span>Ảnh/video</span>
                      </div>
                      <p className="text-sm text-[#657384] dark:text-slate-50">
                        Tải ảnh/video lên
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="p-6 border-t-[#DEE0E6] dark:border-t-slate-700 border-t ">
          {!idPostDetail &&
            (files?.some((f) => f?.type?.startsWith('video')) ? (
              // Đã đính video → nút "Chỉnh sửa" nổi bật (đúng ý: liên kết edit lúc up video, hiện hơn)
              <button
                type="button"
                onClick={() => navigate('/studio')}
                className="mb-3 w-full flex items-center justify-center gap-2 h-11 text-sm font-semibold rounded-lg bg-[#0071A6] text-white hover:bg-[#005f8d]"
              >
                ✂️ Chỉnh sửa video trong Cab Studio (cắt / ghép / nhạc / chữ)
              </button>
            ) : (
              <button
                type="button"
                onClick={() => navigate('/studio')}
                className="mb-3 w-full flex items-center justify-center gap-2 h-10 text-sm font-medium rounded-lg border border-[#0071A6] text-[#0071A6] hover:bg-[#0071A6]/5"
              >
                🎬 Cắt ghép video (Cab Studio)
              </button>
            ))}
          {!idPostDetail ? (
            <ButtonPrimary
              onClick={handleCreateNewPost}
              className="w-full flex justify-center h-10 text-base font-semibold  bg-[#0071A6] rounded-lg"
              disabled={loadingUpload || posting}
              loading={posting}
            >
              Đăng bài
            </ButtonPrimary>
          ) : (
            <ButtonPrimary
              onClick={handleEditPost}
              className="w-full flex justify-center h-10 text-base font-semibold bg-[#0071A6] rounded-lg "
              disabled={loadingUpload}
            >
              Lưu
            </ButtonPrimary>
          )}
        </div>
      </div>
    </DialogComponent>
  );
};

export default ModalCreatePost;
